import { Typography } from '@interstate/components/Typography';
import { kebabCase } from '@makemydeal/dr-common-utils';
import { useSelector, useDispatch } from 'react-redux';
import { InformationCircleIcon } from '@interstate/components/Icons/InformationCircleIcon';
import { Tooltip } from '@interstate/components/Tooltip';
import { DAS_OVERRIDES_FIELDS } from '@makemydeal/dr-dash-store/constants';
import * as dueAtSigningActionCreators from '@makemydeal/dr-dash-store/actions/dueAtSigningActionCreators';
import * as dueAtSigningSelectors from '@makemydeal/dr-dash-store/selectors/dueAtSigningSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { equityAllocationMethodInputStyle, labelWithTooltipStyle, InputWrapper } from './../dealSummary/common/ComponentLabelStyle';
import { SelectInput } from '@interstate/components/SelectInput';
import { EQUITY_ALLOCATION_ORDER, EQUITY_ALLOCATION_METHOD_OPTIONS } from '../constants';
import type { InterstateOnChangeEvent } from '@interstate/components/InterstateEvents';
import type { SelectInputEventValue } from '@interstate/components/SelectInput';
import { dealLockHooks } from '../hooks';
import { utils } from '@makemydeal/dr-offer-redux';

const EquityAllocationMethod = () => {
    const dispatch = useDispatch();
    const isDasLocked = useSelector(dueAtSigningSelectors.getIsDasLocked);
    const isLocked = dealLockHooks.useIsDealLocked();
    const equityAllocationOrderValue = useSelector(dueAtSigningSelectors.getEquityAllocationMethodOverrideWithFallback);
    const isOnePayLease = useSelector(offerReduxSelectors.isOnePayLease);

    const handleChange = (event: InterstateOnChangeEvent<SelectInputEventValue>) => {
        const selectedInputValue = event.target.value as string;
        const dueAtSigningDispatch = dueAtSigningActionCreators.updateDasChanges(DAS_OVERRIDES_FIELDS.EQUITY_ALLOCATION_METHOD);
        dispatch(dueAtSigningDispatch(selectedInputValue));
    };

    const options = EQUITY_ALLOCATION_METHOD_OPTIONS.filter(
        (option) => !(isOnePayLease && utils.isCashEquityAllocationMethod(option.value))
    ).map((option) => ({
        ...option,
        disabled: isLocked
    }));

    return (
        <div style={equityAllocationMethodInputStyle}>
            <div style={labelWithTooltipStyle}>
                <Typography tag="span" variant="h4">
                    Equity Allocation Rule
                </Typography>
                <Tooltip
                    position={'right'}
                    toolTipContent={
                        'Equity Allocation refers to the order of the funding sources that pay down the due in advance items.'
                    }
                    size={'large'}
                    data-testid="equity-allocation-order-checkbox-tooltip"
                >
                    <InformationCircleIcon color="blue" data-testid="equity-allocation-order-information-circle-icon" />
                </Tooltip>
            </div>
            <InputWrapper>
                <SelectInput
                    id="equity-allocation-order-dropdown"
                    name={kebabCase(`${EQUITY_ALLOCATION_ORDER}`)}
                    onChange={handleChange}
                    value={equityAllocationOrderValue}
                    options={options}
                    displayDeselectOption={false}
                    data-testid="equity-allocation-order-dropdown"
                    size="md"
                    disabled={isDasLocked || isLocked}
                />
            </InputWrapper>
        </div>
    );
};

export default EquityAllocationMethod;
